__webpack_require__.p = "https://bmidxbswitzerlanddeplprod.netlify.app/";